function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLanguage = function SvgLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.05 14h4.99c.22-3.15 1.2-6.18 2.84-8.77-4.19.9-7.4 4.43-7.83 8.77ZM15 5.65c-1.69 2.4-2.72 5.3-2.95 8.35h5.9c-.24-3.05-1.27-5.95-2.95-8.35ZM17.95 16c-.24 3.05-1.27 5.95-2.95 8.35-1.69-2.4-2.72-5.3-2.95-8.35h5.9Zm-7.91 0H5.05a9.997 9.997 0 0 0 7.83 8.77c-1.64-2.6-2.62-5.62-2.84-8.77Zm7.08 8.77c1.64-2.6 2.62-5.62 2.84-8.77h4.99a9.997 9.997 0 0 1-7.83 8.77ZM24.95 14h-4.99c-.22-3.15-1.2-6.18-2.84-8.77 4.19.9 7.4 4.43 7.83 8.77ZM3 15C3 8.37 8.37 3 15 3s12 5.37 12 12-5.37 12-12 12S3 21.63 3 15Z",
    style: {
      fillRule: "evenodd"
    }
  }));
};

export default SvgLanguage;